<div [ngClass]="{'d-none': (!fieldsPrerequisite.ampError && ampLoaded) === false}">
    <iframe [src]="ampUrl" frameBorder="0" #iframe width=597px id="iframeId" height=1750px title="AMP"></iframe>
</div>
<div *ngIf="fieldsPrerequisite.ampError">
    There was an error in this part of the application. Please continue the application and return to this part at another time. Any questions please contact our customer service team.
</div>
<app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>